const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Subscribe+to+PLAY+API


function subscribeToPlay(skuId, authData = {}) {
    const userId = require('utils/User').getProfileId();
    let url = '/api/shopping-cart/playSubscription';
    let requestPayload = {
        skuList: [{ skuId: skuId, qty: 1 }]
    };
    if (authData.isNewUserFlow) {
        // API requires email instead of profileId for Play New User Flow
        requestPayload.email = authData.userName;
    } else {
        requestPayload.profileId = userId;
    }
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(requestPayload)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = subscribeToPlay;
